import { Constants } from './loadingConstants'

export function incrementLoadingCounter() {
	return {
		type: Constants.INCREMENT_LOADING_COUNTER,
	} as const
}

export function decrementLoadingCounter() {
	return {
		type: Constants.DECREMENT_LOADING_COUNTER
	} as const
}

export function resetLoadingCounter() {
	return {
		type: Constants.RESET_COUNTER
	} as const
}
